import gql from 'graphql-tag';

export const GET_USER_PAYMENT_METHODS = gql`
  query getUserInformation {
    viewer {
      paymentMethods: payment_methods {
        rawId: raw_id
        hasPaymentIssue: has_payment_issue
        isDefaultPaymentMethod: is_default_payment_method
        paymentCard: payment_card {
          brand
          last4: last_4
          expirationDate: expiration_date
          fundingType: funding_type
        }
      }
    }
  }
`;

export const GET_USER_DEFAULT_PAYMENT_METHOD = gql`
  query getUserInformation {
    viewer {
      defaultPaymentMethod: default_payment_method {
        rawId: raw_id
        hasPaymentIssue: has_payment_issue
        isDefaultPaymentMethod: is_default_payment_method
        paymentCard: payment_card {
          brand
          last4: last_4
          expirationDate: expiration_date
          fundingType: funding_type
        }
      }
    }
  }
`;

export const GET_USER_SUBSCRIPTION_INFO = gql`
  query getUserSubscriptionInfo {
    viewer {
      hasSubscription: has_subscription
      hasActiveSubscription: has_active_subscription
      subscription {
        provider: provider_type
        periodEndsAt: period_ends_at
        status
        subscriptionPlan: subscription_plan {
          amount
          intervalUnit: interval_unit
          planType: plan_type
        }
      }
      hasBeenSubscribed: has_been_subscribed
      hasActiveDiscount: has_active_discount
      cancelAtPeriodEnd: cancel_at_period_end
      nextPaymentAmount: next_payment_amount
      isInFreeTrail: is_in_free_trial
      isPastDueFreeTrial: is_past_due_free_trial
      isPastDue: is_past_due
    }
  }
`;

export const GET_USER_PROFILE = gql`
  query getUserInformation {
    viewer {
      userId: raw_id
      userEmail: email
      firstName: first_name
      username: user_name
      avatar
      role
    }
  }
`;

export const GET_USER_EMAIL = gql`
  query getUserInformation {
    viewer {
      email
    }
  }
`;

export const GET_SUBSCRIPTION_END = gql`
  query UserSubscriptionInfo {
    viewer {
      renewalDate: subscription_period_end
    }
  }
`;

export const GET_USER_ACCOUNT_SETTINGS_INFO = gql`
  query UserAccountSettingsInfo {
    viewer {
      firstName: first_name
      email
    }
  }
`;

export const GET_USER_EMAIL_EXISTS = gql`
  query getUserEmailExists($email: String!) {
    userExists: user_exists(email: $email)
  }
`;
